module.exports = __webpack_public_path__ + "img/80270ed4f915ff2cd40bab456c6aa15c.d5eef18e.jpg";